<template>
  <w-tooltip
    v-model='tooltipOpen'
    :content-class='`w-speed-dial-button${disabled ? "__disabled" : ""}`'
    :bottom='false'
    transition='scale-transition'
    left
  >
    <template #tooltip-activator='{ on, attrs }'>
      <w-icon-button
        v-bind="attrs"
        :disabled='disabled'
        :icon="icon"
        :outlined="false"
        v-on="on"
        @click="$emit('click')"
      />
    </template>

    <template #tooltip>
      {{ label }}
    </template>
  </w-tooltip>
</template>

<script>
/**
 * @component WorkSpeedDialButton
 * @description A single button in the speed dial menu.
 * Shows an icon with tooltip label and supports disabling.
 *
 * @prop {Boolean} [open=false] - Speed dial is open (controls label visibility).
 * @prop {Boolean} [disabled=false] - Disable the button.
 * @prop {String} icon - Icon name. (Required)
 * @prop {String} [color='primary'] - Button color.
 * @prop {String} label - Tooltip text. (Required)
 */
export default {
  name: 'WorkSpeedDialButton',
  props: {
    open: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    icon: { type: String, required: true },
    color: { type: String, default: 'primary' },
    label: { type: String, required: true }
  },
  data() {
    return {
      tooltipOpen: this.open
    };
  },
  watch: {
    open(value) {
      this.tooltipOpen = value;
    }
  }
};
</script>

<style lang='scss'>
.v-tooltip__content.menuable__content__active {
  opacity: 1;
  &.w-speed-dial-button__disabled{
    background-color: var(--v-primary-lighten3) !important;
  }
}
</style>
